import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const coinLogos = {
  BTC: "https://assets.coingecko.com/coins/images/1/small/bitcoin.png",
  ETH: "https://assets.coingecko.com/coins/images/279/small/ethereum.png",
  BNB: "https://assets.coingecko.com/coins/images/825/small/bnb-icon2_2x.png",
  XRP: "https://assets.coingecko.com/coins/images/44/small/xrp-symbol-white-128.png",
  SOL: "https://assets.coingecko.com/coins/images/4128/small/solana.png",
  ADA: "https://assets.coingecko.com/coins/images/975/small/cardano.png",
  DOGE: "https://assets.coingecko.com/coins/images/5/small/dogecoin.png",
  POL: "https://assets.coingecko.com/coins/images/4713/small/matic-token-icon.png",
  LTC: "https://assets.coingecko.com/coins/images/2/small/litecoin.png",
  LINK: "https://assets.coingecko.com/coins/images/877/small/chainlink-new-logo.png",
};

const slugMap = {
  BTC: "bitcoin", ETH: "ethereum", BNB: "bnb", XRP: "xrp",
  SOL: "solana", ADA: "cardano", DOGE: "dogecoin", POL: "polygon",
  LTC: "litecoin", LINK: "chainlink",
};

const CryptoTicker = () => {
  const [prices, setPrices] = useState({});

  useEffect(() => {
    const symbols = [
      "btcusdt", "ethusdt", "bnbusdt", "xrpusdt", "solusdt",
      "adausdt", "dogeusdt", "polusdt", "ltcusdt", "linkusdt"
    ];

    const streams = symbols.map(s => s + "@ticker").join("/");
    const ws = new WebSocket("wss://stream.binance.com:9443/stream?streams=" + streams);

    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      const ticker = data?.data;
      if (!ticker) return;
      setPrices(prev => ({
        ...prev,
        [ticker.s]: {
          price: parseFloat(ticker.c) || 0,
          change: parseFloat(ticker.P) || 0,
        }
      }));
    };

    return () => ws.close();
  }, []);

  const coins = Object.entries(prices || {});
  const tickerData = [...coins, ...coins];

  return (
    <div className="w-full overflow-hidden bg-black border-b border-white/10">
      <style>{`
        .ticker-wrapper {
          display: flex;
          width: max-content;
          animation: tickerScroll 25s linear infinite;
        }
        @keyframes tickerScroll {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-50%); }
        }
        .ticker-wrapper:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div className="ticker-wrapper gap-10 px-6 py-3">
        {tickerData.map(([symbol, data], index) => {
          if (!symbol || !data) return null;
          const cleanSymbol = symbol.replace("USDT", "");
          const logo = coinLogos[cleanSymbol];
          const price = Number(data?.price ?? 0);
          const change = Number(data?.change ?? 0);
          const slug = slugMap[cleanSymbol] || cleanSymbol.toLowerCase();

          return (
            <Link
              to={"/coins/" + slug}
              key={symbol + "-" + index}
              className="flex items-center gap-2 text-sm hover:opacity-80 transition"
            >
              {logo && (
                <img
                  src={logo}
                  alt={cleanSymbol}
                  className="w-5 h-5"
                  onError={(e) => (e.target.style.display = "none")}
                />
              )}
              <span className="text-white font-medium">{cleanSymbol}</span>
              <span className="text-zinc-400">
                {"$" + (Number.isFinite(price) ? price.toLocaleString() : "0.00")}
              </span>
              <span className={change >= 0 ? "text-green-400" : "text-red-400"}>
                {(Number.isFinite(change) ? change.toFixed(2) : "0.00") + "%"}
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default CryptoTicker;